import { render } from "./LoginFormPatient.vue?vue&type=template&id=fe71824a&scoped=true"
import script from "./LoginFormPatient.vue?vue&type=script&lang=js"
export * from "./LoginFormPatient.vue?vue&type=script&lang=js"

import "./LoginFormPatient.vue?vue&type=style&index=0&id=fe71824a&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe71824a"]])

export default __exports__